const stickyHeader = {
  header: document.getElementById('jsStickyHeader') as HTMLElement | undefined,
  mainContent: document.getElementById('main-content') as
    | HTMLElement
    | undefined,
  line: document.getElementById('jsCartLine') as HTMLElement | undefined,
  lineWrap: document.getElementById('jsLineWrap') as HTMLElement | undefined,
  scrollBtn: document.getElementById('jsScrollBtn') as HTMLElement | undefined,
  popups: document.querySelectorAll(
    '.jsStickyPopup',
  ) as NodeListOf<HTMLElement>,
  lastScrollTop: 0,

  init() {
    this.setClass();
    this.setScrollBtn();
    this.reset();
  },

  reset() {
    window.addEventListener('reset', () => {
      document.addEventListener('scroll', () => {
        if (window.scrollY > 250) {
          if (this.lineWrap) {
            this.lineWrap.classList.add('activeClass');
            this.header?.classList.add('activeLine');
          }
        } else {
          this.lineWrap?.classList.remove('activeClass');
          this.header?.classList.remove('activeLine');
        }
      });
    });
  },

  setScrollBtn() {
    window.addEventListener('scroll', () => {
      const st = window.scrollY || document.documentElement.scrollTop;
      if (st > this.lastScrollTop) {
        this.scrollBtn?.classList.add('activeClass');
      } else {
        this.scrollBtn?.classList.add('activeClass');
      }
      this.lastScrollTop = st <= 0 ? 0 : st;

      if (window.scrollY === 0) {
        this.scrollBtn?.classList.remove('activeClass');
      }
    });

    this.scrollBtn?.addEventListener('click', () => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  },

  setClass() {
    document.addEventListener('scroll', () => {
      const st = window.scrollY || document.documentElement.scrollTop;
      if (st > this.lastScrollTop) {
        this.header?.classList.remove('up');
        this.header?.classList.add('down');
        this.mainContent?.classList.remove('up');
        this.mainContent?.classList.add('down');
        this.popups.forEach((popup) => {
          popup.classList.add('activeScroll');
        });
      } else {
        this.header?.classList.add('up');
        this.header?.classList.remove('down');
        this.mainContent?.classList.add('up');
        this.mainContent?.classList.remove('down');
        this.popups.forEach((popup) => {
          popup.classList.add('activeScroll');
        });
      }
      this.lastScrollTop = st <= 0 ? 0 : st;

      if (window.scrollY === 0) {
        this.header?.classList.remove('up');
        this.header?.classList.remove('down');
        this.mainContent?.classList.remove('up');
        this.mainContent?.classList.remove('down');
        if (this.line) {
          this.line.classList.remove('activeClass');
        }
        this.popups.forEach((popup) => {
          popup.classList.remove('activeScroll');
        });
      }

      document.addEventListener('scroll', () => {
        if (window.scrollY > 250) {
          if (this.lineWrap) {
            this.lineWrap.classList.add('activeClass');
            this.header?.classList.add('activeLine');
          }
        } else {
          this.lineWrap?.classList.remove('activeClass');
          this.header?.classList.remove('activeLine');
        }
      });
    });
  },
};

export default stickyHeader;
